import React from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { useBooking } from "@/lib/booking-context";
import { IMAGES } from "@/data/content";

export const FinalCTA = () => {
  const { openBooking } = useBooking();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section ref={ref} className="relative h-[90vh] md:h-screen overflow-hidden flex items-center justify-center" data-testid="final-cta">
      <motion.div style={{ y }} className="absolute inset-0 -top-[12%] -bottom-[12%] will-change-transform">
        <img src={IMAGES.finalCta} alt="Serene luxury bedroom" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/40" />
      </motion.div>

      <div className="relative z-10 text-center px-6">
        <motion.h2
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1.1, ease: [0.16, 1, 0.3, 1] }}
          className="font-serif text-warmwhite font-light text-4xl sm:text-5xl lg:text-7xl leading-[1.08] max-w-4xl mx-auto"
        >
          Experience Home Care Without Compromise.
        </motion.h2>
        <motion.button
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1, delay: 0.3 }}
          onClick={openBooking}
          className="mt-10 px-9 py-4 bg-warmwhite text-charcoal rounded-full text-sm font-semibold transition-all duration-300 hover:bg-champagne hover:text-warmwhite hover:scale-[1.03]"
          data-testid="final-cta-btn"
        >
          Schedule Your Cleaning
        </motion.button>
      </div>
    </section>
  );
};
